// Create a typed bank data object to avoid TypeScript errors
interface BankInfo {
  name: string;
  logo: string;
}

type BankDataType = {
  [key: string]: BankInfo;
};

// Database of common UK banks and their sort code prefixes
// deduced from Wikipedia
const BANK_DATA: BankDataType = {
  "040002": {
    name: "BFC Bank",
    logo: "bfcbank.co.uk",
  },
  "040003": { name: "Monzo", logo: "monzo.com" },
  "040004": { name: "Monzo", logo: "monzo.com" },
  "040005": { name: "Monzo", logo: "monzo.com" },
  "040006": { name: "Monzo", logo: "monzo.com" },
  "040007": { name: "Monzo", logo: "monzo.com" },
  "040008": { name: "Monzo", logo: "monzo.com" },
  "040011": {
    name: "Satabank",
    logo: "satabank.com",
  },
  "040040": {
    name: "Starling Bank",
    logo: "starlingbank.com",
  },
  "040053": {
    name: "Payrnet/Railsbank",
    logo: "railsbank.com",
  },
  "040072": {
    name: "Modulr",
    logo: "modulrfinance.com",
  },
  "040073": {
    name: "Modulr",
    logo: "modulrfinance.com",
  },
  "040074": {
    name: "Modulr",
    logo: "modulrfinance.com",
  },
  "040075": { name: "Revolut", logo: "revolut.com" },
  "040076": { name: "LCH Limited", logo: "lch.com" },
  "040078": {
    name: "Elavon Financial Services",
    logo: "elavon.com",
  },
  "040079": {
    name: "Virgin Money",
    logo: "virginmoney.com",
  },
  "040080": {
    name: "Virgin Money",
    logo: "virginmoney.com",
  },
  "040333": {
    name: "Mettle by NatWest",
    logo: "mettle.co.uk",
  },
  "040405": { name: "ClearBank", logo: "clear.bank" },
  "040476": { name: "Enumis", logo: "enumis.co.uk" },
  "040477": { name: "Enumis", logo: "enumis.co.uk" },
  "040540": {
    name: "BCB Group",
    logo: "bcbgroup.com",
  },
  "040541": {
    name: "BCB Group",
    logo: "bcbgroup.com",
  },
  "040605": { name: "Tide", logo: "tide.co" },
  "041301": {
    name: "Midpoint & Transfer",
    logo: "midpoint.com",
  },
  "041302": {
    name: "Bilderlings Pay",
    logo: "bilderlings.com",
  },
  "041303": {
    name: "Bilderlings Pay",
    logo: "bilderlings.com",
  },
  "041304": {
    name: "Ecology Building Society",
    logo: "ecology.co.uk",
  },
  "041305": {
    name: "Ecology Building Society",
    logo: "ecology.co.uk",
  },
  "041306": {
    name: "Allpay Limited",
    logo: "allpay.net",
  },
  "041307": {
    name: "Clear Junction",
    logo: "clearjunction.com",
  },
  "041308": {
    name: "Clear Junction",
    logo: "clearjunction.com",
  },
  "041312": {
    name: "Modulr",
    logo: "modulrfinance.com",
  },
  "041313": {
    name: "Project Imagine",
    logo: "dozens.com",
  },
  "041314": {
    name: "Project Imagine",
    logo: "dozens.com",
  },
  "041315": {
    name: "Universal Securities & Investment",
    logo: "universalsi.com",
  },
  "041316": {
    name: "Universal Securities & Investment",
    logo: "universalsi.com",
  },
  "041317": {
    name: "Contis Financial Services",
    logo: "contis.com",
  },
  "041318": {
    name: "Contis Financial Services",
    logo: "contis.com",
  },
  "041319": {
    name: "Contis Financial Services",
    logo: "contis.com",
  },
  "041342": { name: "Duesday", logo: "duesday.com" },
  "042909": { name: "Revolut", logo: "revolut.com" },
  "086064": {
    name: "Virgin Money",
    logo: "virginmoney.com",
  },
  "160038": {
    name: "Drummonds Bank",
    logo: "rbs.co.uk",
  },
  "165221": {
    name: "Cumberland Building Society",
    logo: "cumberland.co.uk",
  },
  "165710": {
    name: "Cater Allen Private Bank",
    logo: "caterallen.co.uk",
  },
  "201147": { name: "HMRC", logo: "gov.uk" },
  "230088": {
    name: "VFX Financial",
    logo: "vfxfinancial.com",
  },
  "230505": { name: "Stripe", logo: "stripe.com" },
  "230580": {
    name: "Metro Bank",
    logo: "metrobankonline.co.uk",
  },
  "231470": { name: "Wise", logo: "wise.com" },
  "232221": {
    name: "Fire Financial Services",
    logo: "fire.com",
  },
  "233272": { name: "Pockit", logo: "pockit.com" },
  "235954": {
    name: "Newcastle Building Society",
    logo: "newcastle.co.uk",
  },
  "236972": {
    name: "Prepay Technologies",
    logo: "prepaytechnologies.com",
  },
  "237324": {
    name: "Loot Financial Services",
    logo: "loot.io",
  },
  "300066": {
    name: "Arbuthnot Latham",
    logo: "arbuthnotlatham.co.uk",
  },
  "300083": {
    name: "Al Rayan Bank",
    logo: "alrayanbank.co.uk",
  },
  "300248": {
    name: "FinecoBank UK",
    logo: "finecobank.com",
  },
  "405178": {
    name: "Jyske Bank",
    logo: "jyskebank.com",
  },
  "405198": {
    name: "Turkish Bank UK",
    logo: "turkishbank.co.uk",
  },
  "406080": {
    name: "CashFlows",
    logo: "cashflows.com",
  },
  "406301": {
    name: "Coventry Building Society",
    logo: "coventrybuildingsociety.co.uk",
  },
  "406377": {
    name: "Cynergy Bank",
    logo: "cynergybank.co.uk",
  },
  "406425": {
    name: "Virgin Money",
    logo: "virginmoney.com",
  },
  "406437": {
    name: "Marcus by Goldman Sachs",
    logo: "marcus.co.uk",
  },
  "600173": {
    name: "Reliance Bank",
    logo: "reliancebankltd.com",
  },
  "608312": {
    name: "Atom Bank",
    logo: "atombank.co.uk",
  },
  "608314": {
    name: "Gibraltar International Bank",
    logo: "gibintbank.gi",
  },
  "608366": {
    name: "Fidor Bank UK",
    logo: "fidorbank.uk",
  },
  "608371": {
    name: "Starling Bank",
    logo: "starlingbank.com",
  },
  "608400": { name: "Zopa", logo: "zopa.com" },
  "608407": { name: "Chase UK", logo: "chase.co.uk" },
  "0403": { name: "LHV Pank", logo: "lhv.ee" },
  "0436": {
    name: "Griffin Bank",
    logo: "griffin.sh",
  },
  "0830": { name: "Citibank", logo: "citi.com" },
  "0831": { name: "NS&I", logo: "nsandi.com" },
  "0832": { name: "NS&I", logo: "nsandi.com" },
  "0833": { name: "Citibank", logo: "citi.com" },
  "0834": { name: "Citibank", logo: "citi.com" },
  "0835": { name: "Citibank", logo: "citi.com" },
  "0836": { name: "Citibank", logo: "citi.com" },
  "0837": { name: "Citibank", logo: "citi.com" },
  "0838": { name: "Citibank", logo: "citi.com" },
  "0839": { name: "Citibank", logo: "citi.com" },
  "0860": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0861": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0890": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0891": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0892": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0893": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0894": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0895": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0896": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0897": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0898": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "0899": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "1580": { name: "Child & Co", logo: "rbs.co.uk" },
  "1598": {
    name: "C. Hoare & Co",
    logo: "hoaresbank.co.uk",
  },
  "1599": {
    name: "C. Hoare & Co",
    logo: "hoaresbank.co.uk",
  },
  "4012": {
    name: "M&S Bank",
    logo: "marksandspencer.com",
  },
  "4047": {
    name: "First Direct",
    logo: "firstdirect.com",
  },
  "4064": {
    name: "Tesco Bank",
    logo: "tescobank.com",
  },
  "4999": { name: "Deutsche Bank", logo: "db.com" },
  "01": { name: "NatWest", logo: "natwest.com" },
  "05": {
    name: "Clydesdale Bank",
    logo: "clydesdalebank.co.uk",
  },
  "07": {
    name: "Nationwide",
    logo: "nationwide.co.uk",
  },
  "08": {
    name: "Co-operative Bank",
    logo: "co-operativebank.co.uk",
  },
  "09": {
    name: "Santander UK",
    logo: "santander.co.uk",
  },
  "10": {
    name: "Bank of England",
    logo: "bankofengland.co.uk",
  },
  "11": { name: "Halifax", logo: "halifax.co.uk" },
  "12": {
    name: "Sainsbury's Bank",
    logo: "sainsburysbank.co.uk",
  },
  "13": { name: "Barclays", logo: "barclays.co.uk" },
  "14": { name: "Barclays", logo: "barclays.co.uk" },
  "15": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "16": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "17": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "18": { name: "Coutts", logo: "coutts.com" },
  "19": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "20": { name: "Barclays", logo: "barclays.co.uk" },
  "21": { name: "Barclays", logo: "barclays.co.uk" },
  "22": { name: "Barclays", logo: "barclays.co.uk" },
  "23": { name: "Barclays", logo: "barclays.co.uk" },
  "24": { name: "Barclays", logo: "barclays.co.uk" },
  "25": { name: "Barclays", logo: "barclays.co.uk" },
  "26": { name: "Barclays", logo: "barclays.co.uk" },
  "27": { name: "Barclays", logo: "barclays.co.uk" },
  "28": { name: "Barclays", logo: "barclays.co.uk" },
  "29": { name: "Barclays", logo: "barclays.co.uk" },
  "30": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "31": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "32": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "33": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "34": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "35": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "36": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "37": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "38": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "39": {
    name: "Lloyds Bank",
    logo: "lloydsbank.com",
  },
  "40": { name: "HSBC", logo: "hsbc.com" },
  "41": { name: "HSBC", logo: "hsbc.com" },
  "42": { name: "HSBC", logo: "hsbc.com" },
  "43": { name: "HSBC", logo: "hsbc.com" },
  "44": { name: "HSBC", logo: "hsbc.com" },
  "45": { name: "HSBC", logo: "hsbc.com" },
  "46": { name: "HSBC", logo: "hsbc.com" },
  "47": { name: "HSBC", logo: "hsbc.com" },
  "48": { name: "HSBC", logo: "hsbc.com" },
  "49": { name: "HSBC", logo: "hsbc.com" },
  "50": { name: "NatWest", logo: "natwest.com" },
  "51": { name: "NatWest", logo: "natwest.com" },
  "52": { name: "NatWest", logo: "natwest.com" },
  "53": { name: "NatWest", logo: "natwest.com" },
  "54": { name: "NatWest", logo: "natwest.com" },
  "55": { name: "NatWest", logo: "natwest.com" },
  "56": { name: "NatWest", logo: "natwest.com" },
  "57": { name: "NatWest", logo: "natwest.com" },
  "58": { name: "NatWest", logo: "natwest.com" },
  "59": { name: "NatWest", logo: "natwest.com" },
  "60": { name: "NatWest", logo: "natwest.com" },
  "61": { name: "NatWest", logo: "natwest.com" },
  "62": { name: "NatWest", logo: "natwest.com" },
  "63": { name: "NatWest", logo: "natwest.com" },
  "64": { name: "NatWest", logo: "natwest.com" },
  "65": { name: "NatWest", logo: "natwest.com" },
  "66": { name: "NatWest", logo: "natwest.com" },
  "70": {
    name: "Close Brothers",
    logo: "closebrothers.com",
  },
  "71": { name: "NS&I", logo: "nsandi.com" },
  "72": {
    name: "Santander UK",
    logo: "santander.co.uk",
  },
  "77": { name: "TSB", logo: "tsb.co.uk" },
  "80": {
    name: "Bank of Scotland",
    logo: "bankofscotland.co.uk",
  },
  "81": {
    name: "Bank of Scotland",
    logo: "bankofscotland.co.uk",
  },
  "82": {
    name: "Clydesdale Bank",
    logo: "clydesdalebank.co.uk",
  },
  "83": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "84": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "86": {
    name: "Royal Bank of Scotland",
    logo: "rbs.co.uk",
  },
  "87": { name: "TSB", logo: "tsb.co.uk" },
  "89": {
    name: "Santander UK",
    logo: "santander.co.uk",
  },
  "90": {
    name: "Bank of Ireland",
    logo: "bankofireland.com",
  },
  "91": {
    name: "Danske Bank",
    logo: "danskebank.co.uk",
  },
  "93": {
    name: "Allied Irish Banks",
    logo: "aibgb.co.uk",
  },
  "94": {
    name: "Bank of Ireland",
    logo: "bankofireland.com",
  },
  "95": {
    name: "Danske Bank",
    logo: "danskebank.co.uk",
  },
  "98": {
    name: "Ulster Bank",
    logo: "ulsterbank.co.uk",
  },
};

export function getBankDetails(sortCode: string) {
  // Remove dashes for comparison
  const cleanCode = sortCode.trim().replace(/-/g, "");

  if (cleanCode.length < 2) {
    return null;
  }

  // Try to match with known banks
  const firstTwoDigits = cleanCode.substring(0, 2);
  const firstFourDigits = cleanCode.substring(0, 3);

  let logoPrefix = `https://logo.clearbit.com/`;

  if (BANK_DATA[cleanCode]) {
    return {
      name: BANK_DATA[cleanCode].name,
      logo: `${logoPrefix}${BANK_DATA[cleanCode].logo}`,
    };
  } else if (BANK_DATA[firstFourDigits]) {
    return {
      name: BANK_DATA[firstFourDigits].name,
      logo: `${logoPrefix}${BANK_DATA[firstFourDigits].logo}`,
    };
  } else if (BANK_DATA[firstTwoDigits]) {
    return {
      name: BANK_DATA[firstTwoDigits].name,
      logo: `${logoPrefix}${BANK_DATA[firstTwoDigits].logo}`,
    };
  } else {
    return null;
  }
}
